import { FormControl, FormLabel, Textarea } from '@mui/joy'
import React from 'react'

function EmpfehlungsViewer({ data }) {
    return (
        <>
            <FormControl>
                <FormLabel>Empfehlung</FormLabel>
                <Textarea
                    minRows={8}
                    value={data?.empfehlung}
                    placeholder="Empfehlung..."
                    variant="outlined"
                    
                />
            </FormControl>
        </>
    )
}

export default EmpfehlungsViewer
